module.exports = __webpack_public_path__ + "img/rodenburg.e8cee802.jpg";